import { MintComingDefault } from './MintComingDefault';
import { LogoLayoutNavbar } from './../Home/components/LogoLayoutNavbar';

MintComingDefault.Navbar = LogoLayoutNavbar;

export default MintComingDefault;
